import { render, staticRenderFns } from "./DadosTelefone.vue?vue&type=template&id=41270628&"
import script from "./DadosTelefone.vue?vue&type=script&lang=ts&"
export * from "./DadosTelefone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports